import React from 'react';
import t from 'tcomb-form';
import _ from 'lodash';

import baseFormFactory from './BaseForm';

import GoogleMap from '../components/GoogleMap';
import GoogleLocationInput from '../components/Form_widgets/GoogleLocationInput';
import PhoneFieldComponent from '../components/PhoneFieldComponent';
import TimePicker from '../components/Form_widgets/TimePicker';
import DatePlaceholderInput from '../components/Form_widgets/DatePlaceholderInput';
import moment from 'moment';
import 'moment-timezone';

import {ValidatonError} from '../resources/GenericResource';

const ContactPerson = t.struct({
    name: t.maybe(t.Str),
    phone: t.maybe(t.Str),
    email: t.maybe(t.Str)
});

const ShiftDetailsFormModel = t.struct({
    venue: t.Str,
    address: t.Str,
    country: t.maybe(t.Str),
    city: t.maybe(t.Str),
    street_number: t.maybe(t.Str),
    street: t.maybe(t.Str),
    zip: t.maybe(t.Str),
    start_date: t.Str,
    start_time: t.Str,
    end_time: t.Str,
    description: t.maybe(t.Str),
    contact_persons: t.list(ContactPerson),
    lat: t.Num,
    lng: t.Num
});

function shiftAddressTemplate(locals){
    return <GoogleLocationInput
        callBack={this.handleAddressChange.bind(this)}
        reference={'locationInput'}
        onChange={this.onChange}
        onBlur={this.onBlur.bind(this)}
        types={'address'}
        {...locals}
        placeholder={''}
    />
}

function contactLayout(locals) {
    const key = `${locals.path[0]}_${locals.path[1]}`;
    const error = locals.error && Object.keys(locals.error).filter(x => x.indexOf(key) > -1).length ? 'Fill in missing field data for this row.' : '';
    return (
        <div className={"contact-person " + (error ? "has-error" : "")}>
            <label className="form-control form-control-text contact-person-name">
                <h3 className="label-title">Contact person on site</h3>
                {locals.inputs.name}
                <div className="error-block">{error}</div>
            </label>

            <label className="form-control form-control-text contact-person-tel">
                <h3 className="label-title">Phone</h3>
                {locals.inputs.phone}
            </label>

            <label className="form-control form-control-text contact-person-email">
                <h3 className="label-title">Email</h3>
                {locals.inputs.email}
            </label>
        </div>
    );
}

class FormLayout extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {inputs, value} = this.props;
        const latLng = {lat: value.lat, lng: value.lng};
        const formError = this.props.error || null;
        return (
            <div className={"details-form-content " + (formError ? "has-error" : "")}>
                <div className="error-block">{formError}</div>
                <div className="row row-1">
                    <div className="col col-1">
                        <label className="form-control form-control-text">
                            <h3 className="label-title venue-label">Venue</h3>
                            {inputs.venue}
                        </label>
                        {inputs.address}
                    </div>
                    <div className="col col-2">
                        <GoogleMap center={latLng} zoom={15}/>
                        {inputs.lat}
                        {inputs.lng}
                        {inputs.country}
                        {inputs.city}
                        {inputs.street_number}
                        {inputs.street}
                        {inputs.zip}
                    </div>
                </div>
                <div className="row row-2">
                    <div className="col col-1">
                        {inputs.start_date}
                        <span className="shift-duration">
                            {value.duration ? "Shift duration: " + value.duration : "Specify start and end times to see shift's duration"}
                        </span>
                    </div>
                    <div className="col col-2">
                        <label className="form-control form-control-time">
                            <h3 className="label-title">Start time</h3>
                            {inputs.start_time}
                        </label>
                        <label className="form-control form-control-time">
                            <h3 className="label-title">End time</h3>
                            {inputs.end_time}
                        </label>
                    </div>
                </div>
                <div className="row row-3 row-description">
                    <h3 className="label-title">Description</h3>
                    {inputs.description}
                </div>
                <div className="row row-4 row-contact-persons">
                    <div className="error-msg">{inputs.contact_persons.error}</div>
                    {inputs.contact_persons}
                </div>
            </div>
        );
    }
}

function phoneInputTemplate(locals){
    return (
        <PhoneFieldComponent {...locals}/>
    );
}

const Form = baseFormFactory(ShiftDetailsFormModel, true, true);

class ShiftDetailsForm extends Form {
    constructor(props) {
        super(props);
        let isValid = true;
        let test = Object.values(props.initialFormData);
        for (var i = 0; i < test.length; i++){
            if (typeof test[i] === 'undefined' || test[i] === ''){
                isValid = false;
                break;
            }
        }

        if (typeof props.initialFormData.contact_persons === 'undefined' || props.initialFormData.contact_persons.length == 0) {
            // Open the contact persons widgy to show it's required
            props.initialFormData.contact_persons = [{name: "", phone: "", email: ""}];
        }
        const value = props.initialFormData;
        value.lat = value.lat ? value.lat : 51.500152;
        value.lng = value.lng ? value.lng : -0.126236;

        if (value.start_time && value.end_time) {
            let start_time = value.start_time;
            let end_time = value.end_time;
            if (!moment(value.start_time, 'h:mm A', true).isValid()) {
                start_time = moment(value.start_time).tz(this.props.shift.company.timezone).format('h:mm A');
            }
            if (!moment(value.end_time, 'h:mm A', true).isValid()) {
                end_time = moment(value.end_time).tz(this.props.shift.company.timezone).format('h:mm A');
            }
            const moment_start = moment(start_time, 'h:mm A');
            const moment_end = moment(end_time, 'h:mm A');
            if (moment_end < moment_start) {
                moment_end.add(1, 'days');
            }
            const duration_in_minutes = moment_end.diff(moment_start, 'minutes');
            value.duration = `${Math.floor(duration_in_minutes / 60)}h ${duration_in_minutes % 60}min`;
        } else {
            value.duration = null;
        }

        this.state = {
            value,
            isValid,
            disabled: props.disabled
        };
    }

    handleAddressChange(place) {
        // TODO: There is a small race condition here - we reset all the address fields on blur event and then after we
        // get response from Google we check the existence of city. If city existed in earlier state value and we got
        // response from Google before the blur event fired then the city check would give us wrong results AND we would
        // empty the fields after adding valid data to state.
        const value = this.state.value;
        value.lat = String(place.geometry.location.lat()).substr(0, 12);
        value.lng = String(place.geometry.location.lng()).substr(0, 12);
        value.country = _.result(_.find(place.address_components, comp => {
            return _.includes(comp.types, "country");
        }), 'short_name');
        value.city = _.result(_.find(place.address_components, comp => {
            return _.includes(comp.types, "locality");
        }), 'long_name');
        // Fall back to sublocality if the results didn't include locality.
        if (!value.city) {
            value.city = _.result(_.find(place.address_components, comp => {
                return _.includes(comp.types, "sublocality");
            }), 'long_name');
        }
        value.street_number = _.result(_.find(place.address_components, comp => {
            return _.includes(comp.types, "street_number");
        }), 'long_name');
        value.street = _.result(_.find(place.address_components, comp => {
            return _.includes(comp.types, "route");
        }), 'long_name');
        value.zip = _.result(_.find(place.address_components, comp => {
            return _.includes(comp.types, "postal_code");
        }), 'long_name');
        value.address = place.formatted_address;
        this.setState({value: value});
        this.props.onChange(value);
    }

    cleanContacts(values) {
        return values.contact_persons.filter((item) => {
            return (item.name !== '' && item.name !== null && item.phone !== '' && item.phone !== null && item.email !== '' && item.email !== null);
        });
    }

    validateMissingContactData(values) {
        const result = {};
        values.contact_persons.forEach((item, index) => {
            const checks = [
                item.name == '' || item.name == null,
                item.phone == '' || item.phone == null,
                item.email == '' || item.email == null
            ];
            if (checks.some(x => x == true) && checks.some(x => x == false)) {
                result[`contact_persons_${index}`] = 'Incomplete data';
            }
        });
        return result;
    }

    getValue() {
        let values = this.refs.form.getValue();
        if (values !== null) {
            values = _.extend({}, values);
            const missingContactDataErrors = this.validateMissingContactData(values);
            values.contact_persons = this.cleanContacts(values);

            if (values.contact_persons.length < 1 || Object.keys(missingContactDataErrors).length > 0) {
                values = null;
            }
        }

        return values;
    }

    postValidate(state) {
        const value = this.refs.form.getValue();
        if (state.isValid) {
            const missingContactDataErrors = this.validateMissingContactData(value);
            if (!value.contact_persons || value.contact_persons.length < 1 || this.cleanContacts(value).length < 1) {
                state.isValid = false;
                state.errors = _.merge({}, state.errors, {'contact_persons_generic': 'blabla'});
            }
            if (Object.keys(missingContactDataErrors).length > 0) {
                state.isValid = false;
                state.errors = _.merge({}, state.errors, missingContactDataErrors);
            }
        }
        return state;
    }


    getOptions() {
        const errors = this.props.errors;
        return {
            auto: 'none',

            template: locals => {
                return <FormLayout {...locals}/>;
            },
            hasError: !!(errors && errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('generic') > -1).length),
            error: errors && errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('generic') > -1).length ? errors.errors['generic'] : null,

            fields: {
                venue: {
                    type: 'text',
                    hasError: !!errors,
                    error: errors && errors['venue'] ? "Make sure you named your venue" : errors.errors &&
                        Object.keys(errors.errors).filter(x => x.indexOf('venue') > -1).length ? errors.errors['venue'] : null,
                    disabled: this.state.disabled,
                    attrs: {
                        maxLength: 32
                    }
                },

                address: {
                    type: 'text',
                    template: shiftAddressTemplate.bind(this),
                    hasError: !!errors,
                    error: errors && (errors['address'] ? "Please make sure you added an address" : null),
                    disabled: this.state.disabled
                },

                lat: {
                    type: 'hidden'
                },

                lng: {
                    type: 'hidden'
                },

                start_date: {
                    type: 'text',
                    factory: DatePlaceholderInput,
                    hasError: !!errors,
                    error: errors && errors['start_date'] ? "Please select a date" : null,
                    disabled: this.state.disabled
                },

                start_time: {
                    type: 'text',
                    className: 'time-input',
                    factory: TimePicker,
                    attrs: {
                        onBlur: this.onBlur.bind(this)
                    },
                    hasError: !!errors,
                    error: errors && errors['start_time'] ? (errors['start_time'] || "Please select a time") : null,
                },

                end_time: {
                    type: 'text',
                    className: 'time-input',
                    factory: TimePicker,
                    attrs: {
                        onBlur: this.onBlur.bind(this)
                    },
                    hasError: !!errors,
                    error: errors && errors['end_time'] ? (errors['end_time'] || "Please select a time") : null,
                },

                description: {
                    type: 'textarea',
                    attrs: {
                        cols: 5,
                        rows: 6,
                        className: 'description',
                        placeholder: 'Write briefly about the event, tasks to be performed and other important details. You can set the job position in the next step.'
                    },
                    hasError: !!errors,
                    error: errors && errors['description'] ? "Please write a description" : null
                },

                contact_persons: {
                    disableOrder: true,
                    item: {
                        error: errors,
                        template: contactLayout,
                        fields: {
                            phone: {
                                template: phoneInputTemplate
                            }
                        }
                    },
                    hasError: !!errors,
                    error:
                        errors &&
                        Object.keys(errors).filter(x => x.indexOf('contact_persons_generic') > -1).length ?
                            "Please check that the entered info is correct and that you have entered a correct email address and a phone number" :
                            errors &&
                        errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('contacts') > -1).length ?
                            "Please check that the entered info is correct and that you have entered a correct email address and a phone number":
                            null
                },

                country: {
                    type: 'hidden'
                },

                city: {
                    type: 'hidden'
                },

                street_number: {
                    type: 'hidden'
                },

                street: {
                    type: 'hidden'
                },

                zip: {
                    type: 'hidden'
                }
            }
        };
    }

    onBlur(path) {
        const value = this.state.value;
        if (path.indexOf('address') > -1 && typeof value.address != 'string') {
            value.lat = 51.500152;
            value.lng =  -0.126236;
            value.country = '';
            value.city = '';
            value.street_number = '';
            value.street = '';
            value.zip = '';
            value.address = null;
        }
        if (path.indexOf('start_time') > -1 && !value.start_time) {
            value.start_time = null;
        }
        if (path.indexOf('end_time') > -1 && !value.end_time) {
            value.end_time = null;
        }

        this.setState({value});
    }

    onChange(value, path) {
        if (path.indexOf('start_time') > -1 || path.indexOf('end_time') > -1) {
            if (value.start_time && value.end_time) {
                let start_time = value.start_time;
                let end_time = value.end_time;
                if (!moment(value.start_time, 'h:mm A', true).isValid()) {
                    start_time = moment(value.start_time).tz(this.props.shift.company.timezone).format('h:mm A');
                }
                if (!moment(value.end_time, 'h:mm A', true).isValid()) {
                    end_time = moment(value.end_time).tz(this.props.shift.company.timezone).format('h:mm A');
                }
                const moment_start = moment(start_time, 'h:mm A');
                const moment_end = moment(end_time, 'h:mm A');
                if (moment_end < moment_start) {
                    moment_end.add(1, 'days');
                }
                const duration_in_minutes = moment_end.diff(moment_start, 'minutes');
                value.duration = `${Math.floor(duration_in_minutes / 60)}h ${duration_in_minutes % 60}min`;
            } else {
                value.duration = null;
            }
        }

        if (path.indexOf('address') > -1) {
            const value = this.state.value;
            value.lat = 51.500152;
            value.lng =  -0.126236;
            value.country = null;
            value.city = null;
            value.street_number = null;
            value.street = null;
            value.zip = null;
            value.address = null;
        }

        if (this.props.onChange) {
            this.props.onChange(value);
        }
        super.onChange(value);
    }

    render() {
        return (
            <div>
                <t.form.Form ref="form" value={this.state.value} type={this.getModel()}
                             options={this.buildOptions()} onChange={this.onChange.bind(this)}/>
            </div>
        );
    }
}

ShiftDetailsForm.propTypes = {
    initialFormData: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func,
    shift: React.PropTypes.object.isRequired,
};


export default ShiftDetailsForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/ShiftDetailsForm.js
 **/